import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Info } from "lucide-react";

const HELP = (
  <ul className="list-disc pl-4 space-y-1" data-testid="session-cancel-help">
    <li>Si el alumno avisa dentro del plazo, gana un crédito para usar en alguna sesión de tus talleres.</li>
    <li>Si el alumno avisa fuera del plazo, NO recibirá un crédito para usar en alguna sesión de tus talleres.</li>
  </ul>
);

export function SessionCancelSetting({ workshop, hasSessions, value, onValueChange }) {
  const hours = value;
  const setHours = onValueChange;
  return (
    <div className="rounded-xl border border-border p-3 space-y-2" data-testid="session-cancel-setting">
      <Label className="flex items-center gap-1.5">
        Cancelación sesión
        <TooltipProvider delayDuration={100}>
          <Tooltip>
            <TooltipTrigger asChild>
              <button type="button" className="touch-hit text-primary" aria-label="¿Qué es Cancelación sesión?" data-testid="session-cancel-info"><Info className="w-4 h-4" /></button>
            </TooltipTrigger>
            <TooltipContent className="w-72 max-w-[calc(100vw-1.5rem)] text-xs bg-foreground text-background leading-relaxed p-3" data-testid="session-cancel-info-content">
              <p>Horas de anticipación que tiene un alumno para cancelar o informar que no asistirá a la sesión.</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </Label>
      {hasSessions ? (
        <div className="flex gap-2">
          <Select value={hours} onValueChange={setHours}>
            <SelectTrigger data-testid="ws-notice-hours"><SelectValue /></SelectTrigger>
            <SelectContent>{[2, 4, 6, 8, 10, 12, 24].map((h) => (
              <SelectItem key={h} value={String(h)} data-testid={`notice-hours-${h}`}>{h} horas</SelectItem>
            ))}</SelectContent>
          </Select>
        </div>
      ) : (
        <p className="text-xs text-muted-foreground" data-testid="session-cancel-locked">Agrega al menos una sesión para configurarlo (por defecto: 6 horas).</p>
      )}
      <div className="text-[11px] text-muted-foreground">{HELP}</div>
    </div>
  );
}

export const STATE_INFO = {
  asistio: { label: "Asistes", tip: "El maestro registró tu asistencia en la sesión", cls: "bg-emerald-100 text-emerald-700" },
  cancelo_con_sesion: { label: "Cancelas - recibes crédito", tip: "Cancelaste a tiempo la sesión y recibes un crédito", cls: "bg-sky-100 text-sky-700" },
  cancelo_sin_sesion: { label: "Cancelas - no recibes crédito", tip: "Cancelaste fuera de plazo, no recibes crédito", cls: "bg-amber-100 text-amber-700" },
  no_asistio: { label: "No asistes", tip: "La sesión pasó y no se registró tu asistencia ni cancelación", cls: "bg-rose-100 text-rose-700" },
  confirmada: { label: "Confirmas", tip: "Confirmas que asistirás", cls: "bg-primary/10 text-primary" },
  sin_confirmar: { label: "Sin confirmar", tip: "Aún no confirmas si asistirás", cls: "bg-muted text-muted-foreground" },
};

export function SessionStateIcon({ state, icon: Icon, testId }) {
  const info = STATE_INFO[state] || STATE_INFO.sin_confirmar;
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" className={`grid place-items-center w-8 h-8 rounded-full shrink-0 ${info.cls}`} aria-label={info.label} data-testid={testId} data-state-name={state}>
            <Icon className="w-4 h-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent><p className="font-semibold">{info.label}</p><p className="text-xs">{info.tip}</p></TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
